import { Moment } from 'moment'

import { adminHttpClient } from '../../commons/adminHttpClient'

export type ReviewHistoryItem = {
  reviewedBy: string
  reviewedOn: Moment
  messageToEmployee: string
  internalNotes: string
}

const getExpenseReviewHistory = (expenseId: string): Promise<ReviewHistoryItem[]> => {
  return adminHttpClient.get(`/DocReview/ReviewHistoryDetails/${expenseId}`)
}

export default getExpenseReviewHistory
